import React, { Component } from 'react';
import { injectIntl, FormattedMessage, defineMessages } from 'react-intl';
import { Panel } from 'primereact/panel';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { withRouter, Link } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Paginator from '../../../../components/Paginator';
import { sortUrl, parse, toSortOrder } from '../../../../utils/UrlUtil';
import TableHeader from './SuperlinkImportListHeader';

const messages = defineMessages({
  fileName: { id: 'attrs.fileName', defaultMessage: 'File Name' },
  status: { id: 'attrs.status', defaultMessage: 'Status' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
  updated: { id: 'attrs.updated', defaultMessage: 'Updated' },
});

const statusTemplate = (rowData) => {
  switch (rowData.status) {
    case 'VALID_IMPORT': {
      return (
        <FormattedMessage id="file_import.valid" defaultMessage="Valid">
          {text => <span className="filter filter--info is-active">{text}</span>}
        </FormattedMessage>
      );
    }
    case 'FAILED_IMPORT': {
      return (
        <FormattedMessage id="ile_import.failed" defaultMessage="Failed">
          {text => <span className="filter filter--error is-active">{text}</span>}
        </FormattedMessage>
      );
    }
    case 'ACTIVATED': {
      return (
        <FormattedMessage id="file_import.activated" defaultMessage="Activated">
          {text => <span className="filter filter--success is-active ">{text}</span>}
        </FormattedMessage>
      );
    }
    default: {
      return null;
    }
  }
};

const nameTemplate = (rowData, {
  currentAccount, keyField, displayField, superLinkId,
}) => {
  const detailUrl = `/accounts/${currentAccount}/super-links/${superLinkId}/import/${rowData[keyField]}`;
  return (
    <Link to={detailUrl} className="app-link">
      {rowData[displayField]}
    </Link>
  );
};

const timeFieldTemplate = (rowData, { formatDate, field }) => {
  const updated = formatDate(moment(rowData[field]), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return updated;
};

class SurveyList extends Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }

  onSortChange(event) {
    const { location, history } = this.props;
    sortUrl(event, location, history);
  }

  render() {
    const {
      connection: {
        edges, totalCount, indexFrom, indexTo, pageInfo,
      },
      intl: { formatMessage, formatDate },
      currentAccount,
      loading,
      location,
      match,
    } = this.props;

    const { superLinkId } = match.params;

    // data list
    const listRows = edges.map(({ node }) => ({
      ...node,
    }));

    const params = parse(location.search);
    const { sort = {} } = params;
    const { sortBy, sortDir } = sort;

    // header
    const nameHeader = formatMessage(messages.fileName);
    const statusHeader = formatMessage(messages.status);
    const createdHeader = formatMessage(messages.created);
    const updatedHeader = formatMessage(messages.updated);

    // footer
    const footer = <Paginator totalCount={totalCount} indexFrom={indexFrom} indexTo={indexTo} pageInfo={pageInfo} />;
    return (
      <Panel>
        <div className="p-grid">
          <div className="p-col-12">
            <TableHeader />
          </div>
          <div className="p-col-12">
            <DataTable
              value={listRows}
              responsive
              sortField={sortBy}
              sortOrder={toSortOrder(sortDir)}
              onSort={this.onSortChange}
              lazy
              loading={loading}
              autoLayout
            >
              <Column
                field="fileName"
                header={nameHeader}
                body={nameTemplate}
                keyField="id"
                superLinkId={superLinkId}
                displayField="fileName"
                currentAccount={currentAccount}
                sortable
              />
              <Column field="status" header={statusHeader} body={statusTemplate} />
              <Column
                field="createdOn"
                header={createdHeader}
                body={timeFieldTemplate}
                formatDate={formatDate}
                sortable
              />
              <Column
                field="updatedOn"
                header={updatedHeader}
                body={timeFieldTemplate}
                formatDate={formatDate}
                sortable
              />
            </DataTable>
          </div>
          <div className="p-col-12 align-center">{footer}</div>
        </div>
      </Panel>
    );
  }
}

SurveyList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(injectIntl(SurveyList));
